// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider_container__fmBRJ {
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 4px;
  max-height: 100%; }

.slider_slider__pqBXe {
  display: flex;
  overflow: hidden;
  border-radius: 4px;
  width: 100%;
  max-height: 100%; }

.slider_slides__DnEPo {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
  min-width: 100%;
  max-height: 100%;
  border-radius: 4px;
  object-fit: contain;
  min-height: 300px; }

.slider_buttonLeft__xFt5X {
  z-index: 5;
  fill-opacity: 0.5;
  transition: all 0.4s;
  cursor: pointer; }
  .slider_buttonLeft__xFt5X:hover {
    fill-opacity: 0.9; }

.slider_buttonRight__6zqwk {
  z-index: 5;
  fill-opacity: 0.5;
  transition: all 0.4s;
  cursor: pointer;
  transform: rotate(180deg); }
  .slider_buttonRight__6zqwk:hover {
    fill-opacity: 0.9; }

.slider_dateCount__CYShE {
  display: flex;
  flex-direction: column;
  align-items: center; }

.slider_counter__OCYaT {
  z-index: 5;
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%; }

.slider_datetime__VzJkW {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 190px;
  bottom: 10px;
  left: calc(50% - 95px);
  z-index: 5;
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background: #00000050;
  padding: 2px 10px;
  border-radius: 21px; }
  .slider_datetime__VzJkW .slider_empty__24kA7 {
    width: 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/slider/slider.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB,EAAA;;AAEnB;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,eAAe,EAAA;EAJjB;IAMI,iBAAiB,EAAA;;AAGrB;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yBAAyB,EAAA;EAL3B;IAOI,iBAAiB,EAAA;;AAIrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;;AAErB;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB,EAAA;EAfrB;IAiBI,WAAW,EAAA","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  position: relative;\n  border-radius: 4px;\n  max-height: 100%;\n}\n\n.slider {\n  display: flex;\n  overflow: hidden;\n  border-radius: 4px;\n  width: 100%;\n  max-height: 100%;\n}\n\n.slides {\n  display: flex;\n  transition: transform 0.3s ease;\n  width: 100%;\n  min-width: 100%;\n  max-height: 100%;\n  border-radius: 4px;\n  object-fit: contain;\n  min-height: 300px;\n}\n.buttonLeft {\n  z-index: 5;\n  fill-opacity: 0.5;\n  transition: all 0.4s;\n  cursor: pointer;\n  &:hover {\n    fill-opacity: 0.9;\n  }\n}\n.buttonRight {\n  z-index: 5;\n  fill-opacity: 0.5;\n  transition: all 0.4s;\n  cursor: pointer;\n  transform: rotate(180deg);\n  &:hover {\n    fill-opacity: 0.9;\n  }\n}\n\n.dateCount{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.counter {\n  z-index: 5;\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 120%;\n}\n\n.datetime{\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 190px;\n  bottom: 10px;\n  left: calc(50% - 95px);\n  z-index: 5;\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  background: #00000050;\n  padding: 2px 10px;\n  border-radius: 21px;\n  .empty{\n    width: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `slider_container__fmBRJ`,
	"slider": `slider_slider__pqBXe`,
	"slides": `slider_slides__DnEPo`,
	"buttonLeft": `slider_buttonLeft__xFt5X`,
	"buttonRight": `slider_buttonRight__6zqwk`,
	"dateCount": `slider_dateCount__CYShE`,
	"counter": `slider_counter__OCYaT`,
	"datetime": `slider_datetime__VzJkW`,
	"empty": `slider_empty__24kA7`
};
export default ___CSS_LOADER_EXPORT___;
